import {
  Component,
  HostListener,
  OnInit,
  Inject,
  OnDestroy,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from 'src/app/modules/users/login/login.component';
import { Subscription } from 'rxjs';
import { LoadingService } from 'src/app/core/services/loader.service';
import { UsersService } from 'src/app/modules/users/services/users.service';
import { TooltipPosition } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { ForgotPasswordComponent } from 'src/app/modules/users/forgot-password/forgot-password.component';
import { FeedbackComponent } from 'src/app/modules/side-nav-components/help/feedback/feedback.component';
import { FeedbackPopupComponent } from 'src/app/modules/users/feedback-popup/feedback-popup.component';
import { HeaderNotificationPopupComponent } from 'src/app/modules/user-notification/header-notification-popup/header-notification-popup.component';
import { LoginOtpComponent } from 'src/app/modules/users/login-otp/login-otp.component';
import { WithdrawOpportunityPopupComponent } from 'src/app/modules/users/withdraw-opportunity-popup/withdraw-opportunity-popup.component';
import { ResumeOrStartPopupComponent } from '../resume-or-start-popup/resume-or-start-popup.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public auth: AuthenticationService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private loadingService: LoadingService,
    private userService: UsersService,
    private route: ActivatedRoute
  ) {}
  headerImageSubscription: Subscription;
  userNotificationSubscription: Subscription;
  userDetailSubscription: Subscription;
  signInVal = 'Logout';
  fetchingOpportunityOnLogin: Subscription;
  positionOptions: TooltipPosition = 'right';
  image: any = '';
  primaryUsericon: string;
  imageBlob;
  allNotification = [];
  currentUrl: string;
  userData;
  firstname = 'Adam';
  email = 'adam@gmail.com';
  tryAgainOppFlag = 0;
  tryAgainNotificationFlag = 0;
  menuActive = false;
  sideBarActive = true;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      document.getElementById('appHeader').classList.add('fixedHeader');
    } else {
      document.getElementById('appHeader').classList.remove('fixedHeader');
    }
  }
  ngOnInit() {
    this.updateImage();
    this.updateUserDetail();
    this.allSubscription();
    this.getNotification();
    if (this.auth.isLoggedIn) {
      this.auth.autoLogout();
    }
  }
  feedbackPopup() {
    const dialogRef = this.dialog.open(FeedbackPopupComponent, {
      width: '720px',
      position: { right: '0', bottom: '0' },
      data: { type: 'feedback' },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.auth.showSnackBarMsg('Thanks for the feedback!');
      }
    });
  }
  openHeaderNotificationPopup() {
    const dialogRef = this.dialog.open(HeaderNotificationPopupComponent, {
      width: '720px',
      position: { right: '0', bottom: '0' },
      data: {
        allNotification: this.allNotification,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.auth.showSnackBarMsg('Message sent to team, successfully!')
      }
    });
  }
  onMeassageYourTeam() {
    const dialogRef = this.dialog.open(FeedbackPopupComponent, {
      maxWidth: '600px',
      width: '100%',

      position: { right: '0', bottom: '0' },
      data: { type: 'messagetoTeam' },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.auth.showSnackBarMsg('Message sent to team, successfully!');
      }
    });
  }
  updateUserDetail() {
    if (this.auth.isLoggedIn) {
      this.userData = this.auth.getDecodedUserAccessToken();

      this.firstname = this.userData.contactDetails[0].firstname;
      this.email = this.userData.contactDetails[0].emailaddress1;
      this.primaryUsericon =
        this.userData.contactDetails[0].firstname.trim().charAt(0) +
        this.userData.contactDetails[0].lastname.trim().charAt(0);
    }
  }
  allSubscription() {
    this.headerImageSubscription = this.auth.headerImage.subscribe((value) => {
      if (value) {
        this.updateImage();
      }
    });
    this.userNotificationSubscription = this.auth.headerDetail.subscribe(
      (value) => {
        if (value) {
          this.getNotification();
        } else {
          this.allNotification = [];
        }
      }
    );

    this.userDetailSubscription = this.auth.userDetail.subscribe((value) => {
      if (value) {
        this.updateUserDetail();
      }
    });

    this.fetchingOpportunityOnLogin = this.auth.fetchingData.subscribe(
      (value) => {
        this.fetchCorrespondingData(value);
      }
    );
  }

  updateImage() {
    this.imageBlob = this.auth.getLoginImage();
    if (this.imageBlob) {
      const objectURL = 'data:image/jpeg;base64,' + this.imageBlob;
      this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    } else {
      this.image = '';
    }
  }
  fetchCorrespondingData(route: string) {
    this.currentUrl = route;
    this.getAllOpportunity();
    this.getContries();
    this.getInsuranceProvider();
    this.getAllInstitute();
    this.getOccupation();
    this.getAllRelatedMember();
  }
  ngOnDestroy() {
    this.headerImageSubscription.unsubscribe();
    this.userNotificationSubscription.unsubscribe();
    this.userDetailSubscription.unsubscribe();
    this.fetchingOpportunityOnLogin.unsubscribe();
  }
  logout() {
    this.auth.logout();
    this.image = '';
  }
  handleClick() {
    this.menuActive = !this.menuActive;
  }

  handleSideBarClick() {
    this.sideBarActive = !this.sideBarActive;
  }

  getNotification() {
    if (this.auth.isLoggedIn) {
      // this.loadingService.startLoading();
      // // this.userService
      // //   .getUserNotification(
      // //     this.auth.getUserAccessToken(),
      // //     this.auth.getPrimaryUserId(),
      // //     this.auth.getUserAccountId(),
      // //     3
      // //   )
      // //   .subscribe(
      // //     (response) => {
      // //       // console.log('data we get');
      // //       // console.log(response);
      // //       this.allNotification = [];
      // //       if (response.data) {
      // //         response.data.forEach((element) => {
      // //           const createdBy = element._createdby_value_Formatted.split(' ');
      // //           const notification = {
      // //             createdOn: element.createdon_Formatted,
      // //             subject: element.subject,
      // //             description: element.description,
      // //             statecode: element.statecode,
      // //             statuscode: element.statuscode,
      // //             activityid: element.activityid,
      // //             createdBy: element._createdby_value_Formatted,
      // //             createdBySlug:
      // //               createdBy[0].charAt(0) + createdBy[1].charAt(0),
      // //           };
      // //           this.allNotification.push(notification);
      // //         });
      // //       }
      // //     },
      // //     (err) => {
      // //       ///  this.loadingService.stopLoading();
      // //       console.log('error', err);
      // //       console.log('this.tryAgainNotificationFlag');
      // //       console.log(this.tryAgainNotificationFlag);
      // //       if (this.tryAgainNotificationFlag <= 3) {
      // //         this.tryAgainNotificationFlag++;
      // //         this.auth.headerDetail.next(true);
      // //       }
      // //     }
      // //   );
    } else {
      // console.log('do not get notification, user is not login');
    }
  }
  // Dialog Box
  openDialog(headline: string) {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '500px',
      data: {
        headline,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result === 'forgotPassword') {
          this.openForgotDialog();
        } else if (result === 'otpLogin') {
          this.loginOtp();
        } else if (result === 'onRegister') {
        }
      }
    });
  }
  loginOtp() {
    const dialogRef = this.dialog.open(LoginOtpComponent, {
      width: '500px',
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result === 'backToLogin') {
          this.openDialog('LOGIN TO YOUR ACCOUNT');
        } else if (result === 'forgotPassword') {
          this.openForgotDialog();
        } else if (result === 'onRegister') {
        }
      }
    });
  }
  openForgotDialog() {
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result === 'backToLogin') {
          this.openDialog('LOGIN TO YOUR ACCOUNT');
        }
      }
    });
  }
  showComingSoon() {
    this.auth.showSnackBarMsg('Coming Soon!');
  }
  gotoMessagePage() {
    this.showComingSoon();
    // if (this.router.url !== '/message') {
    //   this.auth.setNotificationBackUrl(this.router.url);
    // }
    // this.redirectToURL('/message');
  }

  getContries() {
    const allContries = this.auth.getAllCountries();

    if (!(allContries && allContries?.length)) {
      this.userService.getCountries(this.auth.getUserAccessToken()).subscribe(
        (response) => {
          this.auth.setAllCountries([...response.data]);
        },
        (error) => {
          this.auth.showSnackBarMsg('Something went wrong!.');
        }
      );
    }
  }

  getInsuranceProvider() {
    const insuranceProvider = this.auth.getAllInsuranceProviderFromSession();

    if (!(insuranceProvider && insuranceProvider.length > 0)) {
      this.userService
        .getInsuranceProvider(this.auth.getUserAccessToken())
        .subscribe(
          (response) => {
            this.auth.setAllInsuranceProviderInSession(response.data);
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  getAllInstitute() {
    const allillionInstitute = this.auth.getAllIllionInstatiteFromSession();

    if (!(allillionInstitute && allillionInstitute.length > 0)) {
      this.userService
        .getAllInstitute(this.auth.getUserAccessToken())
        .subscribe(
          (response) => {
            this.auth.setAllIllionInstatiteInSession(response.data);
          },
          (err) => {
            console.log('getAllInstitute', err);
          }
        );
    }
  }

  getAllRelatedMember() {
    const relatedMember = this.auth.getAllRelatedMemberFromSession();

    if (
      !(
        relatedMember &&
        relatedMember.allRelatedOwner &&
        relatedMember.allRelatedOwner.length > 0
      )
    ) {
      this.userService
        .getAllOwner(
          this.auth.getUserAccessToken(),
          this.auth.getPrimaryUserId()
        )
        .subscribe(
          (response) => {
            this.auth.setAllRelatedMemberInSession(response.data);
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  getOccupation() {
    const occupation = this.auth.getAllOccupationFromSession();

    if (!(occupation && occupation.length > 0)) {
      this.userService.getJobRole(this.auth.getUserAccessToken()).subscribe(
        (response) => {
          if (response.data) {
            this.auth.setAllOccupationInSession(response.data);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  getAllOpportunity() {
    const queryParameter = this.route.snapshot.queryParams;
    this.loadingService.startLoading();
    this.userService
      .getIncompleteOpportunity(
        this.auth.getUserAccessToken(),
        this.auth.getUserAccountId()
      )
      .subscribe(
        (responseValue) => {
          this.loadingService.stopLoading();
          this.auth.setOpportunityinSession(responseValue.data);
          let IsdebtOpp = false;
          let IsSuperOpp = false;
          let IsInvestmentOpp = false;
          let IsHealthOpp = false;
          let IsGeneralOpp = false;
          let IsEstateOpp = false;
          let needRedirect = true;
          let IsFinancialOpp = false;
          let IsLifeOpp = false;
          responseValue.data?.forEach((element) => {
            if (element.tlx_leadfor === 2) {
              // debt opportunity
              IsdebtOpp = true;
              this.auth.setCurrentDebtOpportunityId(element.opportunityid);
              if (
                queryParameter &&
                queryParameter.oppid &&
                queryParameter.oppid.trim().length > 0
              ) {
                if (queryParameter.oppid === element.opportunityid) {
                  needRedirect = false;
                  this.redirectToURL('/user/complete-review-outstanding-items');
                }
              }
              if (this.currentUrl === '/debtapp') {
                const currentStage = element._activestageid_value;
                const currentUrl = this.auth.getDebtCurrentUrl(currentStage);
                needRedirect = false;
                this.resumeOrStart(
                  element.opportunityid,
                  element.tlx_leadfor,
                  element.name,
                  currentUrl
                );
              }
            }
            if (element.tlx_leadfor === 1) {
              // superannuation opportunity
              IsSuperOpp = true;
              this.auth.setCurrentSuperOpportunityId(element.opportunityid);
              if (
                queryParameter &&
                queryParameter.oppid &&
                queryParameter.oppid.trim().length > 0
              ) {
                if (queryParameter.oppid === element.opportunityid) {
                  needRedirect = false;
                  this.redirectToURL(
                    '/superannuation/complete-review-outstanding-items'
                  );
                }
              }
              if (this.currentUrl === '/superannuation') {
                const currentStage = element._activestageid_value;
                const currentUrl = this.auth.getSuperCurrentUrl(currentStage);
                needRedirect = false;
                // if (queryParameter?.uploaddocumentwithemail == 'true') {
                //   if (queryParameter?.queryUser == 'primary') {
                //     this.redirectToURL(
                //       '/superannuation/complete-review-outstanding-items'
                //     );
                //   } else if (queryParameter?.queryUser == 'secondary') {
                //     this.secondaryUserUrl(queryParameter);
                //   } else {
                //     //accountant
                //   }
                // } else {
                this.redirectToURL(currentUrl);
                // }
              }
            }

            if (element.tlx_leadfor === 9) {
              // managed investment opportunity
              IsInvestmentOpp = true;
              this.auth.setCurrentInvestmentOpportunityId(
                element.opportunityid
              );
              // //   const currentStage = element._activestageid_value;
              // //   const currentUrl = this.auth.getSuperCurrentUrl(currentStage);
              if (
                queryParameter &&
                queryParameter.oppid &&
                queryParameter.oppid.trim().length > 0
              ) {
                if (queryParameter.oppid === element.opportunityid) {
                  needRedirect = false;
                  this.redirectToURL(
                    '/managed-account/complete-review-outstanding-items'
                  );
                }
              }
              if (this.currentUrl === '/managed-account') {
                needRedirect = false;
                // if (queryParameter?.uploaddocumentwithemail == 'true') {
                //   if (queryParameter?.queryUser == 'primary') {
                //     this.redirectToURL(
                //       '/managed-account/complete-review-outstanding-items'
                //     );
                //   } else if (queryParameter?.queryUser == 'secondary') {
                //     this.secondaryUserUrl(queryParameter);
                //   } else {
                //     //accountant
                //   }
                // } else {
                this.redirectToURL('/managed-account');
                //  }
              }
            }
            if (element.tlx_leadfor === 4) {
              // general opportunity
              IsGeneralOpp = true;
              this.auth.setCurrentGeneralInsuranceOpportunityId(
                element.opportunityid
              );
              // //  const currentStage = element._activestageid_value;
              // //   const currentUrl = this.auth.getSuperCurrentUrl(currentStage);
              if (
                queryParameter &&
                queryParameter.oppid &&
                queryParameter.oppid.trim().length > 0
              ) {
                if (queryParameter.oppid === element.opportunityid) {
                  needRedirect = false;
                  this.redirectToURL(
                    '/general-insurance/complete-review-outstanding-items'
                  );
                }
              }
              if (this.currentUrl === '/general-insurance') {
                // //    this.redirectToURL(currentUrl);
                needRedirect = false;
                // if (queryParameter?.uploaddocumentwithemail == 'true') {
                //   if (queryParameter?.queryUser == 'primary') {
                //     this.redirectToURL(
                //       '/general-insurance/complete-review-outstanding-items'
                //     );
                //   } else if (queryParameter?.queryUser == 'secondary') {
                //     this.secondaryUserUrl(queryParameter);
                //   } else {
                //     //accountant
                //   }
                // } else {
                this.redirectToURL('/general-insurance');
                //  }
              }
            }
            if (element.tlx_leadfor === 5) {
              // health opportunity
              IsHealthOpp = true;
              this.auth.setCurrentHealthInsuranceOpportunityId(
                element.opportunityid
              );
              // //  const currentStage = element._activestageid_value;
              // //  const currentUrl = this.auth.getSuperCurrentUrl(currentStage);
              if (
                queryParameter &&
                queryParameter.oppid &&
                queryParameter.oppid.trim().length > 0
              ) {
                if (queryParameter.oppid === element.opportunityid) {
                  needRedirect = false;
                  this.redirectToURL(
                    '/health-insurance/complete-review-outstanding-items'
                  );
                }
              }
              if (this.currentUrl === '/health-insurance') {
                // //  this.redirectToURL(currentUrl);
                needRedirect = false;
                // if (queryParameter?.uploaddocumentwithemail == 'true') {
                //   if (queryParameter?.queryUser == 'primary') {
                //     this.redirectToURL(
                //       '/health-insurance/complete-review-outstanding-items'
                //     );
                //   } else if (queryParameter?.queryUser == 'secondary') {
                //     this.secondaryUserUrl(queryParameter);
                //   } else {
                //     //accountant
                //   }
                // } else {
                this.redirectToURL('/health-insurance');
                //  }
              }
            }
            if (element.tlx_leadfor === 6) {
              // estate opportunity
              IsEstateOpp = true;
              this.auth.setCurrentEstatePlanningOpportunityId(
                element.opportunityid
              );
              // //  const currentStage = element._activestageid_value;
              // //   const currentUrl = this.auth.getSuperCurrentUrl(currentStage);
              if (
                queryParameter &&
                queryParameter.oppid &&
                queryParameter.oppid.trim().length > 0
              ) {
                if (queryParameter.oppid === element.opportunityid) {
                  needRedirect = false;
                  this.redirectToURL(
                    '/estate-planning/complete-review-outstanding-items'
                  );
                }
              }
              if (this.currentUrl === '/estate-planning') {
                // //  this.redirectToURL(currentUrl);
                needRedirect = false;
                // if (queryParameter?.uploaddocumentwithemail == 'true') {
                //   if (queryParameter?.queryUser == 'primary') {
                //     this.redirectToURL(
                //       '/estate-planning/complete-review-outstanding-items'
                //     );
                //   } else if (queryParameter?.queryUser == 'secondary') {
                //     this.secondaryUserUrl(queryParameter);
                //   } else {
                //     //accountant
                //   }
                // } else {
                this.redirectToURL('/estate-planning');
                // }
              }
            }
            if (element.tlx_leadfor === 7) {
              // financial planning opportunity
              IsFinancialOpp = true;
              this.auth.setCurrentFinancialPlanningOpportunityId(
                element.opportunityid
              );
              // //  const currentStage = element._activestageid_value;
              // //   const currentUrl = this.auth.getSuperCurrentUrl(currentStage);
              if (
                queryParameter &&
                queryParameter.oppid &&
                queryParameter.oppid.trim().length > 0
              ) {
                if (queryParameter.oppid === element.opportunityid) {
                  needRedirect = false;
                  this.redirectToURL(
                    '/financial-planning/complete-review-outstanding-items'
                  );
                }
              }
              if (this.currentUrl === '/financial-planning') {
                // //  this.redirectToURL(currentUrl);
                needRedirect = false;
                // if (queryParameter?.uploaddocumentwithemail == 'true') {
                //   if (queryParameter?.queryUser == 'primary') {
                //     this.redirectToURL(
                //       '/financial-planning/complete-review-outstanding-items'
                //     );
                //   } else if (queryParameter?.queryUser == 'secondary') {
                //     this.secondaryUserUrl(queryParameter);
                //   } else {
                //     //accountant
                //   }
                // } else {
                this.redirectToURL('/financial-planning');
                // }
              }
            }
            if (element.tlx_leadfor === 3) {
              // life and personal insurance opportunity
              IsLifeOpp = true;
              this.auth.setCurrentLifeInsuranceOpportunityId(
                element.opportunityid
              );
              // //  const currentStage = element._activestageid_value;
              // //   const currentUrl = this.auth.getSuperCurrentUrl(currentStage);
              if (
                queryParameter &&
                queryParameter.oppid &&
                queryParameter.oppid.trim().length > 0
              ) {
                if (queryParameter.oppid === element.opportunityid) {
                  needRedirect = false;
                  this.redirectToURL(
                    'life-insurance/complete-review-outstanding-items'
                  );
                }
              }
              if (this.currentUrl === '/life-insurance') {
                // //  this.redirectToURL(currentUrl);
                needRedirect = false;
                // if (queryParameter?.uploaddocumentwithemail == 'true') {
                //   if (queryParameter?.queryUser == 'primary') {
                //     this.redirectToURL(
                //       '/life-insurance/complete-review-outstanding-items'
                //     );
                //   } else if (queryParameter?.queryUser == 'secondary') {
                //     this.secondaryUserUrl(queryParameter);
                //   } else {
                //     //accountant
                //   }
                // } else {
                this.redirectToURL('/life-insurance');
                //  }
              }
            }
          });
          if (!IsdebtOpp) {
            this.auth.setCurrentDebtOpportunityId('');
            if (this.currentUrl === '/debtapp') {
              needRedirect = false;

              this.redirectToURL('/debtapp');
              // }
            }
          }
          if (!IsSuperOpp) {
            this.auth.setCurrentSuperOpportunityId('');
            if (this.currentUrl === '/superannuation') {
              needRedirect = false;

              this.redirectToURL('/superannuation');
              // }
            }
          }
          if (!IsInvestmentOpp) {
            this.auth.setCurrentInvestmentOpportunityId('');
            if (this.currentUrl === '/managed-account') {
              needRedirect = false;

              this.redirectToURL('/managed-account');
              //  }
            }
          }
          if (!IsHealthOpp) {
            this.auth.setCurrentHealthInsuranceOpportunityId('');
            if (this.currentUrl === '/health-insurance') {
              needRedirect = false;

              this.redirectToURL('/health-insurance');
              //  }
            }
          }
          if (!IsGeneralOpp) {
            this.auth.setCurrentGeneralInsuranceOpportunityId('');
            if (this.currentUrl === '/general-insurance') {
              needRedirect = false;

              this.redirectToURL('/general-insurance');
              //  }
            }
          }
          if (!IsEstateOpp) {
            this.auth.setCurrentEstatePlanningOpportunityId('');
            if (this.currentUrl === '/estate-planning') {
              needRedirect = false;

              this.redirectToURL('/estate-planning');
              //  }
            }
          }
          if (!IsFinancialOpp) {
            this.auth.setCurrentFinancialPlanningOpportunityId('');
            if (this.currentUrl === '/financial-planning') {
              needRedirect = false;

              this.redirectToURL('/financial-planning');
              //  }
            }
          }
          if (!IsLifeOpp) {
            this.auth.setCurrentLifeInsuranceOpportunityId('');
            if (this.currentUrl === '/life-insurance') {
              needRedirect = false;

              this.redirectToURL('/life-insurance');
              //  }
            }
          }
          if (needRedirect) {
            if (
              queryParameter &&
              queryParameter.oppid &&
              queryParameter.oppid.trim().length > 0
            ) {
              this.auth.showSnackBarMsg(
                'Opps! The opportunity is no longer available.'
              );
            }

            this.redirectToURL('/');
            // }
          }
          this.loadingService.stopLoading();
          // if (queryParameter?.uploaddocumentwithemail != 'true') {
          //   this.auth.resetUserForm.emit(false);
          // }
        },
        (error) => {
          console.log(error);
          this.loadingService.stopLoading();
          if (this.tryAgainOppFlag <= 3) {
            this.tryAgainOppFlag++;
            this.auth.showSnackBarMsg('Something Went Wrong,Please wait....');
            this.auth.fetchingData.next(this.auth.getCurrentUrl());
          } else {
            this.auth.showSnackBarMsg(
              'Something Went Wrong, Please Try again after some time.'
            );
            this.auth.logout();
          }
        }
      );
  }
  resumeOrStart(
    oppId: string,
    leadFor: string,
    name: string,
    currentUrl: string
  ) {
    const dialogRef = this.dialog.open(ResumeOrStartPopupComponent, {
      width: '400px',
      data: {
        name,
        currentPage: 'userForm',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result === 'resume') {
          this.redirectToURL(currentUrl);
        } else {
          this.auth.showSnackBarMsg(
            `Please withdraw current ${name} application.`,
            9000
          );
          this.disableOpportunity(oppId, +leadFor, currentUrl);
          // this.redirectToURL(this.startNewUrl);
        }
      } else {
        this.redirectToURL(currentUrl);
      }
    });
  }
  disableOpportunity(oppID: string, leadFor: number, currentUrl: string) {
    const dialogRef = this.dialog.open(WithdrawOpportunityPopupComponent, {
      width: '720px',
      position: { right: '0', bottom: '0' },
      data: { type: 'add', data: oppID, leadFor },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.auth.setCurrentDebtOpportunityId('');
        // this.redirectToURL('financial-goal');
      } else {
        this.redirectToURL(currentUrl);
      }
    });
  }

  redirectToURL(url = '') {
    // this.showComingSoon();
    // this.router.navigate([url]);
    // window.scroll(0, 0);
    this.auth.gotoUrl(url);
  }

  pathToSubnav(route: string) {
    // if (this.router.url !== route) {
    //   this.auth.setBackUrl(this.router.url);
    // }
    if (this.auth.getCurrentUrl() !== route) {
      this.auth.setBackUrl(this.auth.getCurrentUrl());
    }
    this.redirectToURL(route);
  }
}
